import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useState } from "react";
import SpecialText from "../../../components/common/Typography/SpecialText";
import InteractiveText from "../../../components/common/Typography/InteractiveText";
import AuxiliaryText from "../../../components/common/Typography/AuxiliaryText";
import { BiLike, BiDislike } from "react-icons/bi";
import {
  PUBLIC_HELP_CENTRE_BLOCK_GAP_CLASS,
  PUBLIC_HEADING_TO_CONTENT_CLASS,
  PUBLIC_HEADING_TO_BODY_CLASS,
  PUBLIC_SECTION_GAP_CLASS,
  PUBLIC_IMAGE_TO_HEADING_CLASS,
  PUBLIC_HEADING_ROW_GAP_CLASS,
} from "../../Public/shared/publicLayoutSpec";

const HelpCenterDetails = () => {
  const navigate = useNavigate();
  const { state = {} } = useLocation();
  
  // State for helpful votes
  const [helpfulVotes, setHelpfulVotes] = useState({
    2: { up: 0, down: 0, userVote: null }
  });

  const {
    displayContent = "",
    displayTitle = "",
    displayList = [],
    displayList2 = [],
    displayList3 = [],
    displayList4 = [],
    displayList5 = [],
    displayListLabel = "",
    displayListLabel2 = "",
    displayListLabel3 = "",
    displayListLabel4 = "",
    displayListLabel5 = "",
    displayInlineHeadingList = [],
    displayFooterNote = "",
    displayExtraParagraph = "",
    link = "",
    title = "",
    displayDropdowntitle = "",
  } = state;

  const handleHelpfulVote = (reviewIndex, voteType) => {
    setHelpfulVotes(prev => {
      const currentReview = prev[reviewIndex];
      const newVote = currentReview.userVote === voteType ? null : voteType;
      
      let newUp = currentReview.up;
      let newDown = currentReview.down;
      
      // Remove previous vote if exists
      if (currentReview.userVote === 'up') newUp--;
      if (currentReview.userVote === 'down') newDown--;
      
      // Add new vote
      if (newVote === 'up') newUp++;
      if (newVote === 'down') newDown++;
      
      return {
        ...prev,
        [reviewIndex]: {
          up: newUp,
          down: newDown,
          userVote: newVote
        }
      };
    });
  };

  return (
    <>
      <div className={`w-full border-b border-b-mediumgray pb-12 ${PUBLIC_HELP_CENTRE_BLOCK_GAP_CLASS}`}>
        <span
          onClick={() => {
            navigate(link, {
              state: state,
              replace: true,
            });
          }}
        >
          <SpecialText
            variant={"NavigationPath"}
            className={`text-offblack flex items-center ${PUBLIC_HEADING_ROW_GAP_CLASS} hover:text-primaryblue`}
          >
            <i class="fi fi-rr-undo-alt pb-1"></i>
            {title ? (
              <Link className="text-offblack hover:text-primaryblue pb-1">
                {title}
              </Link>
            ) : (
              <Link className="text-offblack hover:text-primaryblue pb-1">
                {displayDropdowntitle}
              </Link>
            )}
          </SpecialText>
        </span>
        {displayTitle && (
          <InteractiveText
            variant={"FAQHeader"}
            className={`text-offblack ${PUBLIC_HEADING_TO_CONTENT_CLASS}`}
          >
            {displayTitle}
          </InteractiveText>
        )}
        {displayContent && (
          <InteractiveText variant={"FAQAnswer"} className={`text-offblack ${PUBLIC_HEADING_TO_BODY_CLASS}`}>
            {displayContent}
          </InteractiveText>
        )}
        {displayExtraParagraph && (
          <InteractiveText variant={"FAQAnswer"} className={`text-offblack ${PUBLIC_HEADING_TO_BODY_CLASS}`}>
            {displayExtraParagraph}
          </InteractiveText>
        )}
        {displayInlineHeadingList && displayInlineHeadingList.length > 0 && (
          <ul className="ml-0">
            {displayInlineHeadingList.map((e) => {
              return (
                <li key={e.darkHeading}>
                  <div className={PUBLIC_HEADING_TO_BODY_CLASS}>
                    <div className={`flex items-center ${PUBLIC_HEADING_ROW_GAP_CLASS}`}>
                      <InteractiveText
                        variant={"FAQAnswer"}
                        className={"font-semibold text-offblack"}
                      >
                        {e.darkHeading}&nbsp;
                      </InteractiveText>
                    </div>
                    <InteractiveText
                      variant={"FAQAnswer"}
                      className={`text-offblack ${PUBLIC_HEADING_TO_BODY_CLASS}`}
                    >
                      {e.InlineParagraph}
                    </InteractiveText>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
        {displayListLabel && displayList && displayList.length > 0 && (
          <>
            <InteractiveText
              variant={"FAQAnswer"}
              className={`mb-4 ${PUBLIC_IMAGE_TO_HEADING_CLASS} text-offblack`}
            >
              {displayListLabel}
            </InteractiveText>
            <ul className="ml-0">
              {displayList.map((item, index) => (
                <li key={index} className={`flex capitalize ${PUBLIC_HEADING_TO_BODY_CLASS}`}>
                  <InteractiveText variant={"FAQAnswer"} className={"capitalize"}>
                    {item.listItem}
                  </InteractiveText>
                </li>
              ))}
            </ul>
          </>
        )}
        {displayListLabel2 && displayList2 && displayList2.length > 0 && (
          <>
            <InteractiveText
              variant={"FAQAnswer"}
              className={`mb-4 ${PUBLIC_SECTION_GAP_CLASS} text-offblack`}
            >
              {displayListLabel2}
            </InteractiveText>
            <ul className="ml-0">
              {displayList2.map((item, index) => (
                <li key={index} className={`flex capitalize ${PUBLIC_HEADING_TO_BODY_CLASS}`}>
                  <InteractiveText variant={"FAQAnswer"} className={"capitalize"}>
                    {item.listItem2}
                  </InteractiveText>
                </li>
              ))}
            </ul>
          </>
        )}
        {displayListLabel3 && displayList3 && displayList3.length > 0 && (
          <>
            <InteractiveText variant={"FAQAnswer"} className={`mb-4 ${PUBLIC_SECTION_GAP_CLASS}`}>
              {displayListLabel3}
            </InteractiveText>
            <ul className="ml-0">
              {displayList3.map((item, index) => (
                <li key={index} className={`flex capitalize ${PUBLIC_HEADING_TO_BODY_CLASS}`}>
                  <InteractiveText variant={"FAQAnswer"} className={"capitalize"}>
                    {item.listItem3}
                  </InteractiveText>
                </li>
              ))}
            </ul>
          </>
        )}
        {displayListLabel4 && displayList4 && displayList4.length > 0 && (
          <>
            <InteractiveText variant={"FAQAnswer"} className={`mb-4 ${PUBLIC_SECTION_GAP_CLASS}`}>
              {displayListLabel4}
            </InteractiveText>
            <ul className="ml-0">
              {displayList4.map((item, index) => (
                <li key={index} className={`flex capitalize ${PUBLIC_HEADING_TO_BODY_CLASS}`}>
                  <InteractiveText variant={"FAQAnswer"} className={"capitalize"}>
                    {item.listItem4}
                  </InteractiveText>
                </li>
              ))}
            </ul>
          </>
        )}
        {displayListLabel5 && displayList5 && displayList5.length > 0 && (
          <>
            <InteractiveText variant={"FAQAnswer"} className={`mb-4 ${PUBLIC_SECTION_GAP_CLASS}`}>
              {displayListLabel5}
            </InteractiveText>
            <ul className="ml-0">
              {displayList5.map((item, index) => (
                <li key={index} className={`flex capitalize ${PUBLIC_HEADING_TO_BODY_CLASS}`}>
                  <InteractiveText variant={"FAQAnswer"} className={"capitalize"}>
                    {item.listItem5}
                  </InteractiveText>
                </li>
              ))}
            </ul>
          </>
        )}
        {displayFooterNote && (
          <SpecialText variant={"FootNoteDisclaimer"} className={PUBLIC_IMAGE_TO_HEADING_CLASS}>
            {displayFooterNote}
          </SpecialText>
        )}
      </div>
      <div className={`w-full ${PUBLIC_HEADING_TO_BODY_CLASS} flex items-center`}>
        <div>
          <SpecialText
            variant={"DateStamp"}
            className={"flex items-center text-offblack"}
          >
            8 months ago
          </SpecialText>
        </div>
        <div className="mx-2">
          <i className="fi fi-ss-bullet text-[10px] text-offblack"></i>
        </div>
        <div>
          <SpecialText
            variant={"DateStamp"}
            className={"flex items-center text-offblack"}
          >
            Updated
          </SpecialText>
        </div>
        <div className="mx-2">
          <i className="fi fi-ss-bullet text-[10px] text-offblack"></i>
        </div>
        <div className={`flex items-center ${PUBLIC_HEADING_ROW_GAP_CLASS}`}>
          <AuxiliaryText variant={"Placeholder"} className={"text-offblack"}>
            Helpful?
          </AuxiliaryText>
          <button
            onClick={() => handleHelpfulVote(2, 'up')}
            className={`flex items-center gap-1 rounded-md transition-colors ${
              helpfulVotes[2].userVote === 'up' 
                ? 'text-green-600' 
                : ''
            }`}
          >
            <BiLike className="text-base" />
            <SpecialText variant={"Counter"}>
              ({helpfulVotes[2].up})
            </SpecialText>
          </button>
          <button
            onClick={() => handleHelpfulVote(2, 'down')}
            className={`flex items-center gap-1 rounded-md transition-colors ${
              helpfulVotes[2].userVote === 'down' 
                ? 'text-red-600' 
                : ''
            }`}
          >
            <BiDislike className="text-base" />
            <SpecialText variant={"Counter"}>
              ({helpfulVotes[2].down})
            </SpecialText>
          </button>
        </div>
      </div>
    </>
  );
};

export default HelpCenterDetails;
